import React from "react";
import CloseIcon from "assets/icons/close.svg?react";
import styles from "./index.module.scss";
import {
    BannerButtonProps,
    BannerLinkProps,
    MessageContentState
} from "../types";
import { exists } from "helpers/booleans";
import { BannerContent } from "./BannerContent";
import { t } from "i18next";
import { Link } from "react-router-dom";

export interface BannerProps {
    header?: string;
    hide?: boolean;
    setHide?: (state: boolean) => void;
    subheader?: string;
    canClose?: boolean;
    cssClass?: string;
    icon?: React.ReactNode;
    /** @deprecated This seems to be only used for one specific use case. Leaving in but considering it deprecated */
    bannerContentMessage?: MessageContentState;
    buttonProps?: BannerButtonProps;
    linkProps?: BannerLinkProps;
    rightMessage?: string;
}

export const Banner: React.FC<BannerProps> = ({
    header,
    subheader,
    hide,
    setHide,
    canClose,
    cssClass,
    icon = <></>,
    bannerContentMessage,
    buttonProps,
    linkProps,
    rightMessage
}) =>
    !hide && (
        <div
            className={`${styles["banner-container"]} ${
                cssClass ? styles[`banner-${cssClass}`] : ""
            }`}
        >
            <div
                className={`${styles["banner"]} ${
                    !canClose && buttonProps ? styles["wrap"] : ""
                }`}
            >
                <div className={styles["icon-text-container"]}>
                    {icon}
                    {exists(bannerContentMessage) ? (
                        <BannerContent messageProps={bannerContentMessage} />
                    ) : (
                        <span className={styles["message"]}>
                            {header} <br></br>
                            <small>{subheader ? subheader : ""}</small>
                            {linkProps && (
                                <small>
                                    <span>{rightMessage}</span>
                                    <Link
                                        to={linkProps.href}
                                        onClick={linkProps.onClick}
                                    >
                                        {t(linkProps.text)}
                                    </Link>
                                </small>
                            )}
                        </span>
                    )}
                </div>
                {buttonProps && (
                    <button
                        className={`btn ${buttonProps.type} ${
                            styles[buttonProps.className] ?? ""
                        } ${styles["cta-button"]}`}
                        type="button"
                        onClick={buttonProps.onClick}
                    >
                        {buttonProps.label}
                    </button>
                )}
                {canClose && (
                    <button
                        className={styles["close-btn"]}
                        onClick={() => setHide(true)}
                    >
                        <CloseIcon />
                    </button>
                )}
            </div>
        </div>
    );
